import axios from 'axios';
import authService from './authService';
import { API_URL } from '@/config/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = authService.token.get();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
    }
    return Promise.reject(error);
  }
);

export default {
  /**
   * Obter saldo atual de gamificação
   */
  getSaldo() {
    return api.get('/gamificacao/saldo');
  },

  /**
   * Obter informações de streak
   */
  getStreak() {
    return api.get('/gamificacao/streak');
  },

  /**
   * Obter histórico completo
   */
  getHistorico() {
    return api.get('/gamificacao/historico');
  },

  /**
   * Obter histórico por data específica
   * @param {string} data - Data no formato yyyy-MM-dd
   */
  getHistoricoPorData(data) {
    return api.get(`/gamificacao/historico/${data}`);
  },

  /**
   * Obter histórico por período
   * @param {string} dataInicio - Data inicial no formato yyyy-MM-dd
   * @param {string} dataFim - Data final no formato yyyy-MM-dd
   */
  getHistoricoPorPeriodo(dataInicio, dataFim) {
    return api.get('/gamificacao/historico/periodo', {
      params: {
        inicio: dataInicio,
        fim: dataFim
      }
    });
  }
};

